"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boschBookingResponseSchema = exports.boschPriceResponseSchema = exports.boschRestAreaDetailSchema = exports.boschFeatureItemSchema = exports.boschAddressSchema = exports.boschFeeStructureItemSchema = exports.boschPositionSchema = exports.boschRestAreaListItemSchema = void 0;
const zod_1 = require("zod");
// An explicit z.ZodObject<Shape> annotation truncates the generated .d.ts to a partial
// generic; consumers with strictNullChecks:false (e.g. routing-functions) then recompute
// Output/Input and every field turns optional. Leave this to inference so the compiled
// .d.ts bakes in the full, consumer-proof type.
exports.boschRestAreaListItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    status: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.boschPositionSchema = zod_1.z.object({
    latitude: zod_1.z.number(),
    longitude: zod_1.z.number(),
});
exports.boschFeeStructureItemSchema = zod_1.z.object({
    unit: zod_1.z.string(),
    duration: zod_1.z.number(),
    netPrice: zod_1.z.string(),
    currency: zod_1.z.string(),
    lastUpdated: zod_1.z.string(),
});
exports.boschAddressSchema = zod_1.z.object({
    name: zod_1.z.string(),
    street1: zod_1.z.string(),
    city: zod_1.z.string(),
    zip: zod_1.z.string(),
    isoCountryCode: zod_1.z.string(),
});
exports.boschFeatureItemSchema = zod_1.z.object({
    id: zod_1.z.number(),
    key: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.string(),
    icon: zod_1.z.string().optional(),
});
exports.boschRestAreaDetailSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    status: zod_1.z.string(),
    description: zod_1.z.string().optional(),
    position: exports.boschPositionSchema,
    fees: zod_1.z.string(),
    parkingSlots: zod_1.z.number(),
    feeStructure: zod_1.z.array(exports.boschFeeStructureItemSchema).optional(),
    address: exports.boschAddressSchema,
    features: zod_1.z.array(exports.boschFeatureItemSchema),
    openingHours: zod_1.z.string().optional(),
});
exports.boschPriceResponseSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    netPrice: zod_1.z.number(),
    taxPrice: zod_1.z.number(),
    taxRate: zod_1.z.number(),
    currency: zod_1.z.string(),
    accessTypeKeys: zod_1.z.array(zod_1.z.string()),
    availableSpaces: zod_1.z.number(),
});
exports.boschBookingResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    totalAmount: zod_1.z.number(),
    state: zod_1.z.string(),
    startDate: zod_1.z.string(),
    endDate: zod_1.z.string(),
    earliestStartDate: zod_1.z.string(),
    currency: zod_1.z.string(),
    areaKey: zod_1.z.string(),
    accessInformation: zod_1.z.array(zod_1.z.object({ accessTypeKey: zod_1.z.string(), value: zod_1.z.string() })),
    bookingType: zod_1.z.string(),
});
//# sourceMappingURL=bosch.js.map